<template>
  <v-tooltip bottom :disabled="!description">
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        class="service-chip"
        :class="chipClasses"
        v-bind="attrs"
        v-on="on"
        @click="!isDeleted ? handleSelect() : handleRevertDelete()"
      >
        <v-icon left size="20px">
          {{ chipIcon }}
        </v-icon>
        <div>
          <div class="service-chip__title">
            {{ name }}
          </div>
          <div v-if="isDeleted" class="service-chip__deleted-label">
            {{ $t("message.facilityDetails.services.clickToRestore") }}
          </div>
          <div v-if="showPrice" class="service-chip__price">
            {{ $t("message.facilityDetails.services.price") }}: {{ price }}
          </div>
        </div>
        <div
          v-if="isActive"
          class="service-chip__action"
          @click.stop="toggleValue"
        >
          <v-icon size="22px">
            icon-settings-cog
          </v-icon>
        </div>
      </v-chip>
    </template>
    <span>{{ description }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "GmbServiceChip",
  props: {
    name: {
      type: String,
      required: true
    },
    price: {
      type: String
    },
    value: {
      type: [Boolean]
    },
    description: {
      type: String
    },
    deleteMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chipClasses() {
      return {
        "is-deleted": this.isDeleted,
        "is-active": this.isActive
      };
    },
    chipIcon() {
      if (this.isDeleted) return "icon-trash";
      if (this.value) return "icon-check";
      return "icon-plus";
    },
    isActive() {
      return this.value && !this.deleteMode;
    },
    isDeleted() {
      return this.value && this.deleteMode;
    },
    showPrice() {
      return this.isActive && this.price;
    }
  },
  methods: {
    handleRevertDelete() {
      this.$emit("revert-delete");
    },
    handleSelect() {
      if (!this.isActive) {
        this.toggleValue();
      } else {
        this.handleDelete();
      }
    },
    handleDelete() {
      this.$emit("delete");
    },
    toggleValue() {
      this.$emit("input");
    }
  }
};
</script>
<style lang="scss" scoped>
.service-chip {
  display: inline-flex;
  user-select: none;
  padding: 0 $spacing * 2;

  &__deleted-label {
    @include font-size(10px);
    line-height: 11px;
  }

  &.is-active {
    background: $primary !important;
    padding-right: 0;
  }

  &.is-active,
  &.is-deleted {
    color: white;
    .v-icon {
      color: white;
    }
  }

  &.is-deleted {
    background: $pink-1 !important;
  }

  &__title {
    @include font-size(13px);
    line-height: 1em;
    font-weight: 500;
  }

  &__price {
    @include font-size(11px);
    line-height: 1em;
    font-weight: 500;
    margin-top: $spacing * 0.2;
  }

  &__action {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    border-left: 1px solid $gray-800;
    margin-left: $spacing;
    box-sizing: content-box;

    .v-icon {
      color: white;
      margin-left: -1px;
    }

    &:hover {
      background: darken($primary, 10%);
    }
  }

  &.v-chip {
    cursor: pointer;
    user-select: none;
    min-height: 38px;
    border-radius: 20px;
    @include font-size(14px);
    white-space: normal;

    &__content {
      display: block;
      height: 100%;
    }

    &:not(.v-chip--active) {
      background: $base-light;
      &:hover {
        background: darken($base-light, 5%);
      }
    }

    &:hover::before {
      opacity: 0;
    }
  }
}
</style>
